import React, { useState } from 'react';
import toast from 'reusable-components/notifications/toast';
import { useDebugModeStore } from '~/stores/debug';

const CSS = require('./VersionNumber.module.scss');

const APPLICATION_VERSION = withlocals_version;

function VersionNumber() {
  const debugModeStore = useDebugModeStore();
  const [clickCount, setClickCount] = useState(0);

  const handleClick = () => {
    const newClickCount = clickCount + 1;
    if (newClickCount > 2) {
      toast({
        toastId: 'debug-mode-toast',
        text: `Click ${7 - newClickCount} more times to activate debug mode.`,
        position: 'bottom-center',
      });
    }
    if (newClickCount === 7) {
      debugModeStore.setDebugMode(true);
      setClickCount(0);
    } else {
      setClickCount(newClickCount);
    }
  };

  if (!APPLICATION_VERSION) {
    return null;
  }

  return (
    <div className={CSS.VersionNumber} onClick={handleClick}>
      version {APPLICATION_VERSION}
    </div>
  );
}

export default VersionNumber;
